import React, { FC, useState } from 'react'
import { createStyles, FormControl, Button, CircularProgress, Theme } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { TLoginFormData } from '../../Models/Auth/@types';
import { userLogin } from './redux-config';
import { OApp } from '../../Models/App';
import { RouteComponentProps } from 'react-router';
import { makeStyles } from '@material-ui/styles';
import { TDispatch } from 'Typings/Global';


const Auth: FC<RouteComponentProps> = ({ history }) => {

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<TLoginFormData>({ email: '', password: '' });
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => setFormData({ ...formData, [event.target.name]: event.target.value });

    const handleSubmit = async () => {
        setLoading(true);
        await dispatch(userLogin(formData)).catch(
            error => {
                setLoading(false);
                OApp.showToast({ message: 'Invalid Credentials', variant: 'ERROR' });
                throw error;
            });
        history.push('/dashboard');
    }

    return (
        <div className={classes.landingPageContainer}>
            <div className={classes.formContainer}>
                <ValidatorForm
                    onSubmit={handleSubmit}
                >
                    <FormControl fullWidth className={classes.formControl} >
                        <TextValidator
                            label="Email"
                            onChange={handleChange}
                            name="email"
                            validators={['required', 'isEmail']}
                            errorMessages={['Required', 'Email is not valid']}
                            fullWidth
                            value={formData.email}
                        />
                    </FormControl>
                    <FormControl
                        fullWidth
                        className={classes.formControl}
                    >
                        <TextValidator
                            label="Password"
                            onChange={handleChange}
                            name="password"
                            type="password"
                            validators={['required']}
                            errorMessages={['Required']}
                            fullWidth
                            value={formData.password}
                        />
                    </FormControl>
                    <Button type="submit" fullWidth variant="contained" color="primary" size="large" disabled={loading}>
                        {
                            loading
                                ?
                                <CircularProgress thickness={5} color='inherit' />
                                :
                                'Submit'
                        }
                    </Button>
                </ValidatorForm>
            </div>
        </div>
    )
}

const STYLES = (theme: Theme) => createStyles({
    landingPageContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center'
    },
    logoContainer: {
        marginBottom: 30,
        '& > img': {
            maxWidth: '100%'
        }
    },
    formContainer: {
        maxWidth: 300,
        margin: '0 auto'
    },
    formControl: {
        marginBottom: 30
    }
});

const useStyles = makeStyles(STYLES);

export default Auth;